import { render, staticRenderFns } from "./DataLabel.vue?vue&type=template&id=7cd49a32&scoped=true&"
import script from "./DataLabel.vue?vue&type=script&lang=ts&"
export * from "./DataLabel.vue?vue&type=script&lang=ts&"
import style0 from "./DataLabel.vue?vue&type=style&index=0&id=7cd49a32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd49a32",
  null
  
)

export default component.exports